module.exports = __webpack_public_path__ + "static/customer_journey_mapping-bc96c36c0abfba691d53cb4906c62455.jpg";